import styled from 'styled-components'
import Text from '../../general/Typography/Text/Text'
import HelpPopover from './components/HelpPopover'
import { ReactNode } from 'react'
import { Heading, MoreInfoLink } from '../../general'
import { Tag } from 'antd'
import BasicPageHeader, { BasicPageHeaderProps } from './BasicPageHeader'

export type PageHeaderProps = BasicPageHeaderProps & {
  help?: {
    title?: string
    content: ReactNode
  }
  isThirdPartyData?: boolean
  moreInfoLink?: string
  childrenTitle?: React.ReactNode
  sticky?: boolean
}

export const THIRD_PARTY_DATA = 'THIRD PARTY DATA'

const PageHeader = (props: PageHeaderProps) => {
  const {
    help,
    isThirdPartyData,
    moreInfoLink,
    children,
    childrenTitle,
    title,
    sticky = false,
    ...restProps
  } = props
  return (
    <StickyWrapper $sticky={sticky}>
      {sticky && <PageHeaderSpace />}
      <BasicPageHeader
        {...restProps}
        title={
          <>
            {title ? (
              <HeadingStyled level={1}>{title}</HeadingStyled>
            ) : (
              childrenTitle
            )}
            {help && (
              <StyledHelpPopover title={help?.title} content={help?.content} />
            )}
            {moreInfoLink && (
              <ChildWrapper>
                <MoreInfoLink helpArticleUrl={moreInfoLink} />
              </ChildWrapper>
            )}
            {isThirdPartyData && (
              <ChildWrapper>
                <Tag color="orange">
                  <Text level={2}>{THIRD_PARTY_DATA}</Text>
                </Tag>
              </ChildWrapper>
            )}
          </>
        }
      >
        {children}
      </BasicPageHeader>
      {sticky && <PageHeaderGradient />}
    </StickyWrapper>
  )
}

const StickyWrapper = styled.div<{ $sticky?: boolean }>`
  ${({ $sticky }) =>
    $sticky &&
    `
    position: sticky;
    top: 0;
    z-index: 10;
    max-width: 1080px;
    margin: 0 auto;
    `}
`

const PageHeaderGradient = styled.div`
  height: 24px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.color.neutral.color9},
    transparent
  );
`

const PageHeaderSpace = styled.div`
  height: 24px;
  background-color: ${({ theme }) => theme.color.neutral.color9};
`

const StyledHelpPopover = styled(HelpPopover)`
  margin-left: 16px;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: none;
  }
`

const HeadingStyled = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3} !important;
  white-space: nowrap;
  margin-right: 20px;
`

const ChildWrapper = styled.div`
  margin-left: 12px;
`

export default PageHeader
